"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var RoleSwitchModal_component_exports = {};
__export(RoleSwitchModal_component_exports, {
  RoleSwitchModal: () => RoleSwitchModal,
  roleLabels: () => roleLabels
});
module.exports = __toCommonJS(RoleSwitchModal_component_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_react = require("react");
var import_Dialog = require("@greatmindsorg/gmui-lib/dist/components/Dialog/Dialog.component");
var import_Header = require("@greatmindsorg/gmui-lib/dist/components/Dialog/Header/Header.component");
var import_Body = require("@greatmindsorg/gmui-lib/dist/components/Dialog/Body/Body.component");
var import_Footer = require("@greatmindsorg/gmui-lib/dist/components/Dialog/Footer/Footer.component");
var import_Radio = require("@greatmindsorg/gmui-lib/dist/components/Radio/Radio.component");
var import_Button = require("../../Button/Button.component");
const roleLabels = {
  teacher: "Teacher",
  "district-admin": "District administrator",
  "school-admin": "School administrator"
};
const RoleSwitchModal = ({
  currentRole,
  availableRoles,
  onSwitchRole
}) => {
  const [isSwitchRoleModalOpen, setIsSwitchRoleModalOpen] = (0, import_react.useState)(false);
  const [selectedRole, setSelectedRole] = (0, import_react.useState)("");
  const handleRadioSelect = (value) => {
    setSelectedRole(value);
  };
  const handleSwitchRole = () => {
    if (onSwitchRole && selectedRole) onSwitchRole(selectedRole);
    setIsSwitchRoleModalOpen(false);
  };
  const toggleModal = () => {
    setIsSwitchRoleModalOpen(!isSwitchRoleModalOpen);
  };
  const handleRadioChange = (value) => {
    handleRadioSelect(value);
  };
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)("div", { children: [
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_Button.Button, { variant: "secondary", className: "mt-2", onPress: toggleModal, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_Button.Button.Label, { children: "Switch roles" }) }),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
      import_Dialog.Dialog,
      {
        open: isSwitchRoleModalOpen,
        closeOnEscape: true,
        closeOnOverlayClick: true,
        onOpenChange: setIsSwitchRoleModalOpen,
        children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_jsx_runtime.Fragment, { children: [
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_Header.Header, { children: "Switch roles" }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_Body.Body, { children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
            import_Radio.RadioGroup,
            {
              label: "Switch to:",
              orientation: "vertical",
              radioGroupLabelStyles: "text-base font-bold mb-5",
              onChange: handleRadioChange,
              children: availableRoles.map((role, index) => /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_Radio.Radio, { value: role, isDisabled: role === currentRole, children: [
                /* @__PURE__ */ (0, import_jsx_runtime.jsx)("span", { className: "capitalize", children: roleLabels[role] || role }),
                role === currentRole && " (current role)"
              ] }, index))
            }
          ) }),
          /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_Footer.Footer, { children: /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(import_Footer.Footer.RightContainer, { children: [
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
              import_Button.Button,
              {
                variant: "secondary",
                size: "medium",
                onPress: toggleModal,
                className: "w-full lg:w-auto",
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_Button.Button.Label, { children: "Cancel" })
              }
            ),
            /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
              import_Button.Button,
              {
                variant: "primary",
                size: "medium",
                onPress: handleSwitchRole,
                testId: "gmui-avatar-popup-role-switch-button",
                className: "w-full lg:w-auto",
                children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_Button.Button.Label, { children: "Switch" })
              }
            )
          ] }) })
        ] })
      }
    )
  ] });
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  RoleSwitchModal,
  roleLabels
});
//# sourceMappingURL=RoleSwitchModal.component.js.map